import React, { useState, useEffect } from 'react';
import { getContactSubmissions, deleteContactSubmission } from '../../services/adminApi';
import './ContactSubmissionsList.css';

const ContactSubmissionsList = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSubmissions();
  }, []);

  const loadSubmissions = async () => {
    try {
      setLoading(true);
      const data = await getContactSubmissions();
      setSubmissions(data);
    } catch (error) {
      console.error('Error loading contact submissions:', error);
      alert('Не удалось загрузить сообщения');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить это сообщение?')) {
      return;
    }

    try {
      await deleteContactSubmission(id);
      loadSubmissions();
    } catch (error) {
      console.error('Error deleting submission:', error);
      alert('Не удалось удалить сообщение');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Загрузка сообщений...</div>;
  }

  return (
    <div className="contact-submissions-list">
      <div className="list-header">
        <h2>Сообщения из формы обратной связи</h2>
        <button onClick={loadSubmissions} className="btn-refresh"> Обновить</button>
      </div>

      {submissions.length === 0 ? (
        <div className="empty-state">
          <p>Нет сообщений</p>
        </div>
      ) : (
        <div className="submissions-container">
          {submissions.map((submission) => (
            <div key={submission.id} className="submission-card">
              <div className="submission-header">
                <div className="submission-info">
                  <div className="submission-name">{submission.name}</div>
                  <div className="submission-contact">
                    {submission.whatsapp && (
                      <div className="contact-item">
                        <span className="contact-badge whatsapp">WhatsApp</span>
                        <span className="contact-value">{submission.whatsapp}</span>
                      </div>
                    )}
                    {submission.telegram && (
                      <div className="contact-item">
                        <span className="contact-badge telegram">Telegram</span>
                        <span className="contact-value">{submission.telegram}</span>
                      </div>
                    )}
                  </div>
                  <div className="submission-date">{formatDate(submission.created_at)}</div>
                </div>
                <button 
                  onClick={() => handleDelete(submission.id)} 
                  className="btn-delete"
                >
                  Удалить
                </button>
              </div>
              <div className="submission-message">
                {submission.message}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactSubmissionsList;

